module.exports = __webpack_public_path__ + "static/media/confeitaria-marina-cardapio.64589246.jpg";